import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { loginAdmin } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    const user = localStorage.getItem('adminUser');
    if (token && user) {
      try {
        setAdmin(JSON.parse(user));
      } catch {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const data = await loginAdmin(email.trim(), password);
      localStorage.setItem('adminToken', data.token);
      const user = { name: data.name, email: data.email, role: data.role, avatar: data.avatar };
      localStorage.setItem('adminUser', JSON.stringify(user));
      setAdmin(user);
      return { success: true };
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Invalid Email or Password');
    }
  };

  const logout = useCallback(() => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setAdmin(null);
  }, []);

  const isAuthenticated = !!localStorage.getItem('adminToken');

  return (
    <AuthContext.Provider value={{ admin, login, logout, isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
